import Link from './link';
import Redirect from './redirect';
import Route from './route';
import Router from './router';
import Switch from './switch';
import NavLink from './nav-link';
import withRouter from './with-router';
import Prompt from './prompt';
import Garden from './garden';

// @compat react-router-redux
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

export {
  Link,
  Redirect,
  Route,
  Router,
  Switch,
  NavLink,
  withRouter,
  Prompt,
  Garden,
  LOCATION_CHANGE,
};
